import React from "react";
import ReactDOM from "react-dom";
import { RecoilRoot } from "recoil";
import "./brochure.css";
import reportWebVitals from "./reportWebVitals";
import Router from "./routes";

ReactDOM.render(
  <RecoilRoot>
    <Router />
  </RecoilRoot>,
  document.getElementById("root")
);

reportWebVitals();
